/* Shopify cart layer: routes every add / change / remove through the
   Shopify Cart API (/cart/add.js, /cart/change.js) and re-renders the
   cart drawer with the Section Rendering API (sections=shared-cart-drawer).
   Loads after the page scripts and takes over the demo localStorage cart
   while keeping the exact same drawer markup and interactions. */
(function () {
  'use strict';
  var SECTION = 'shared-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, inflight = 0;

  function $(s, c) { return (c || document).querySelector(s); }
  function toast(msg) { if (typeof window.showToast === 'function') { try { window.showToast(msg); } catch (e) {} } }


  /* ---- add-to-cart notification (small toast, replaces opening the whole cart drawer) ---- */
  var atcTimer = null;
  function atcEl() {
    var el = document.getElementById('atcToast'); if (el) return el;
    var st = document.createElement('style');
    st.textContent = '#atcToast{position:fixed;z-index:99999;top:18px;right:18px;width:min(360px,calc(100vw - 24px));background:#fff;color:#0a0a0a;border:1.5px solid #0a0a0a;border-radius:14px;box-shadow:0 14px 34px -10px rgba(0,0,0,.35);padding:.7rem .8rem;display:flex;align-items:center;gap:.75rem;font-family:"Plus Jakarta Sans",system-ui,sans-serif;transform:translateY(-16px);opacity:0;visibility:hidden;pointer-events:none;transition:transform .22s ease,opacity .22s ease,visibility .22s}#atcToast.show{transform:none;opacity:1;visibility:visible;pointer-events:auto}#atcToast .atc__img{width:52px;height:52px;border-radius:10px;background:#F1E7C4;flex-shrink:0;object-fit:contain;display:block}#atcToast .atc__body{min-width:0;flex:1}#atcToast .atc__t{display:flex;align-items:center;gap:.35rem;font-weight:800;font-size:.82rem;color:#1eb473;margin:0 0 .12rem}#atcToast.atc--err .atc__t{color:#d92d20}#atcToast .atc__n{font-weight:700;font-size:.9rem;line-height:1.2;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#atcToast .atc__m{margin:.1rem 0 0;font-size:.76rem;color:#6b6b6b}#atcToast .atc__v{flex-shrink:0;background:#0a0a0a;color:#fff;border:0;border-radius:10px;padding:.55rem .8rem;font:700 .78rem "Plus Jakarta Sans",sans-serif;cursor:pointer}#atcToast .atc__v:hover{background:#ff0000}@media(max-width:600px){#atcToast{top:auto;bottom:14px;right:12px;left:12px;width:auto;transform:translateY(16px)}}';
    document.head.appendChild(st);
    el = document.createElement('div'); el.id = 'atcToast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    el.addEventListener('mouseenter', function () { clearTimeout(atcTimer); });
    el.addEventListener('mouseleave', function () { atcTimer = setTimeout(hideAtc, 2200); });
    el.addEventListener('click', function (e) { if (e.target.closest('.atc__v')) { hideAtc(); openCart(); } });
    document.body.appendChild(el); return el;
  }
  function hideAtc() { var el = document.getElementById('atcToast'); if (el) el.classList.remove('show'); }
  function showAtc(o) {
    var el = atcEl(), err = !!o.error;
    el.classList.toggle('atc--err', err);
    var esc2 = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    el.innerHTML = (o.img && !err ? '<img class="atc__img" src="' + esc2(o.img) + '" alt="">' : '') +
      '<div class="atc__body"><p class="atc__t">' + (err ? '! Could not add' : '&#10003; Added to cart') + '</p><p class="atc__n">' + esc2(String(o.name == null ? '' : o.name).split(' - Ready to ')[0]) + '</p>' +
      (o.meta ? '<p class="atc__m">' + esc2(o.meta) + '</p>' : '') + '</div>' +
      (err ? '' : '<button type="button" class="atc__v">View cart</button>');
    void el.offsetWidth; el.classList.add('show');
    clearTimeout(atcTimer); atcTimer = setTimeout(hideAtc, err ? 3500 : 3200);
  }

  /* ---- drawer open / close (fresh lookups, no stale references) ---- */
  function openCart() {
    var d = $('#drawer'), o = $('#overlay');
    if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
    if (o) o.classList.add('open');
    setTimeout(cdNav, 320);
  }
  function closeCart() {
    var d = $('#drawer'), o = $('#overlay');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('open');
  }
  window.openCart = openCart;
  window.closeCart = closeCart;
  window.render = function () {};
  try { localStorage.removeItem('surtiflavour_cart'); } catch (e) {}

  /* ---- render drawer from server HTML ---- */
  function applySection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newItems = doc.getElementById('drawerItems'), newTotal = doc.getElementById('cartTotal'), newDrawer = doc.getElementById('drawer');
    var items = $('#drawerItems'), total = $('#cartTotal'), count = $('#cartCount');
    if (items && newItems) items.innerHTML = newItems.innerHTML;
    if (total && newTotal) total.textContent = newTotal.textContent;
    var n = newDrawer ? newDrawer.getAttribute('data-item-count') : null;
    if (count && n !== null) count.textContent = n;
    var d = $('#drawer'); if (d && n !== null) d.setAttribute('data-item-count', n);
    var ng = doc.getElementById('cdGoal'), g = $('#cdGoal'); if (g && ng) { g.setAttribute('data-free', ng.getAttribute('data-free')); g.innerHTML = ng.innerHTML; }
    var nu = doc.getElementById('cdUpWrap'), u = $('#cdUpWrap'); if (u && nu) { u.innerHTML = nu.innerHTML; cdNav(); }
    var db = $('#drawerCount'); if (db && n !== null) db.textContent = n;
  }
  function refresh() {
    return fetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { applySection(j[SECTION]); })
      .catch(function () {});
  }

  /* ---- Cart API ---- */
  var chain = Promise.resolve();
  function post(url, body) {
    inflight++;
    var run = function () { return rawPost(url, body); };
    var p = chain.then(run, run);
    chain = p.catch(function () {});
    return p;
  }
  function rawPost(url, body) {
    busy = true;
    return fetch(ROOT + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTION }, body))
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { inflight--; if (inflight <= 0) { inflight = 0; applySection(j.sections && j.sections[SECTION]); busy = false; } return j; })
      .catch(function (err) { inflight = Math.max(0, inflight - 1); busy = false; showAtc({ error: true, name: (err && (err.description || err.message)) || 'Could not update cart' }); if (!inflight) refresh(); throw err; });
  }
  /* Adding a product that is already in the cart ADDS the selected quantity to its existing line (accumulates). */
  function addItems(items, label, info) {
    items = items.filter(function (i) { return i.id && i.quantity > 0; });
    if (!items.length) return Promise.resolve();
    var list = $('#drawerItems'), existing = [], fresh = [];
    items.forEach(function (i) {
      var row = list ? list.querySelector('.ci[data-vid="' + i.id + '"]') : null;
      if (row) existing.push({ i: i, row: row }); else fresh.push(i);
    });
    existing.forEach(function (e) {
      if (e.row.classList.contains('ci--pending')) return;
      var row = e.row, qEl = row.querySelector('.qty span'), q0 = qEl ? (parseInt(qEl.textContent, 10) || 0) : (parseInt(row.getAttribute('data-q'), 10) || 0), q = q0 + e.i.quantity; e.total = q;
      var unit = parseInt(row.getAttribute('data-unit'), 10) || 0;
      var tEl = $('#cartTotal'), cc = $('#cartCount');
      if (tEl && unit) { var tv = parseInt((tEl.textContent || '').replace(/[^0-9]/g, ''), 10) || 0; tEl.textContent = '₹' + Math.max(0, tv + (q - q0) * unit); }
      if (cc) cc.textContent = Math.max(0, (parseInt(cc.textContent, 10) || 0) + (q - q0));
      if (qEl) qEl.textContent = q;
      setPk(row, q);
      var bi = row.querySelector('[data-inc]'), bd = row.querySelector('[data-dec]');
      if (bi) bi.setAttribute('data-qty', q + 1); if (bd) bd.setAttribute('data-qty', q - 1);
      row.setAttribute('data-q', q);
    });
    if (fresh.length) optimisticAdd(label, fresh.reduce(function (n, i) { return n + i.quantity; }, 0), existing.length ? null : info, fresh[0].id);
    var qtyAll = items.reduce(function (n, i) { return n + i.quantity; }, 0);
    showAtc({ name: label || 'Item', img: info && info.img, meta: (qtyAll > 1 ? qtyAll + ' items' : '1 item') + (info && info.price ? ' · ₹' + info.price : '') });
    var p = Promise.resolve();
    existing.forEach(function (e) { p = p.then(function () { return e.total ? post('cart/change.js', { id: String(e.i.id), quantity: e.total }) : post('cart/add.js', { items: [e.i] }); }); });
    if (fresh.length) p = p.then(function () { return post('cart/add.js', { items: fresh }); });
    return p;
  }
  function optimisticAdd(label, qty, info, vid) {
    var items = $('#drawerItems'), count = $('#cartCount'), empty = $('#drawerEmpty');
    if (count) count.textContent = (parseInt(count.textContent, 10) || 0) + qty;
    var dd = $('#drawer'); if (dd) dd.setAttribute('data-item-count', String((count && parseInt(count.textContent, 10)) || qty));
    if (empty) empty.style.display = 'none';
    if (!items) return;
    var old = items.querySelector('.ci--pending'); if (old) old.remove();
    var row = document.createElement('div');
    row.className = 'ci ci--pending'; if (vid) row.setAttribute('data-vid', vid);
    row.innerHTML = '<div class="ci__thumb"></div><div class="ci__info"><p class="ci__name"></p></div><div class="ci__side"><b class="ci__price"></b><p class="ci__meta"></p></div>';
    row.querySelector('.ci__name').textContent = String(label || '').split(' - Ready to ')[0];
    row.querySelector('.ci__price').textContent = info && info.price ? '₹' + info.price : '';
    row.querySelector('.ci__meta').textContent = 'Adding…';
    if (info && info.img) { var im = document.createElement('img'); im.src = info.img; im.alt = ''; im.width = 60; im.height = 60; row.querySelector('.ci__thumb').appendChild(im); }
    var tt = $('#cartTotal'); if (tt && info && info.price) { var cur = parseInt((tt.textContent || '').replace(/[^0-9]/g, ''), 10) || 0; tt.textContent = '₹' + (cur + info.price); }
    items.insertBefore(row, items.firstChild);
  }
  function setPk(row, q) { var k = row && row.querySelector('.ci__pk'); if (k) k.textContent = (parseInt(k.getAttribute('data-u'), 10) || 1) * q; var u = row ? parseInt(row.getAttribute('data-unit'), 10) || 0 : 0, pe = row && row.querySelector('.ci__price'); if (pe && u) pe.textContent = '₹' + (u * q); }
  /* free-delivery goal follows the drawer total, also during optimistic updates */
  function cdSync() {
    var t = $('#cartTotal'), g = $('#cdGoal'); if (!t || !g) return;
    var s = parseInt((t.textContent || '').replace(/[^0-9]/g, ''), 10) || 0, free = parseInt(g.getAttribute('data-free'), 10) || 999, left = free - s, done = left <= 0;
    var T = $('#cdGoalT'), A = $('#cdGoalA'), F = $('#cdFill'), M = $('#cdMs'), R = $('#cdRail');
    if (T) T.innerHTML = done ? '<b>Free delivery unlocked</b>' : 'Add <b>₹' + left + '</b> more for <b>free delivery</b>';
    if (A) A.innerHTML = '<b>₹' + Math.min(s, free) + '</b> / ₹' + free;
    if (F) F.style.width = (done ? 100 : Math.max(0, s / free * 100)) + '%';
    if (M) M.classList.toggle('on', done);
    if (R) R.setAttribute('aria-valuenow', Math.min(s, free));
  }
  function cdNav() {
    var l = $('#cdUpList'), p = $('#cdUpPrev'), n = $('#cdUpNext'); if (!l || !p || !n) return;
    var max = l.scrollWidth - l.clientWidth, at = l.scrollLeft; p.disabled = at <= 1; n.disabled = at >= max - 1;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#cdUpPrev,#cdUpNext'); if (!b) return;
    var l = $('#cdUpList'), c = l && l.querySelector('.cd-uc'); if (!l) return;
    l.scrollBy({ left: (b.id === 'cdUpPrev' ? -1 : 1) * (c ? c.getBoundingClientRect().width + 12 : 136), behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) { if (e.target && e.target.id === 'cdUpList') cdNav(); }, true);
  document.addEventListener('wheel', function (e) {
    var l = e.target.closest && e.target.closest('#cdUpList'); if (!l) return;
    var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX, max = l.scrollWidth - l.clientWidth;
    if (!d || max <= 0) return;
    if ((d < 0 && l.scrollLeft <= 0) || (d > 0 && l.scrollLeft >= max - 1)) return;
    e.preventDefault(); l.scrollBy({ left: d, behavior: 'instant' });
  }, { passive: false });
  (function () {
    var t = $('#cartTotal'), c = $('#cartCount'), dc = $('#drawerCount');
    if (t && window.MutationObserver) new MutationObserver(cdSync).observe(t, { childList: true, characterData: true, subtree: true });
    if (c && dc && window.MutationObserver) new MutationObserver(function () { dc.textContent = c.textContent; }).observe(c, { childList: true, characterData: true, subtree: true });
    cdNav(); window.addEventListener('resize', cdNav);
  })();
  function changeLine(line, quantity) { return post('cart/change.js', { line: line, quantity: quantity }); }

  /* ---- variant resolution: pack quantity -> real pack variant ---- */
  function variantsOf(el) {
    var raw = el && el.getAttribute('data-variants'); if (!raw) return [];
    try { return JSON.parse(raw); } catch (e) { return []; }
  }
  function resolve(el, packQ) {
    var base = parseInt(el.getAttribute('data-add'), 10);
    var list = variantsOf(el);
    var hit = list.filter(function (v) { return String(v.q) === String(packQ); })[0];
    if (hit) return { id: hit.id, quantity: 1, price: hit.p };
    var first = list.filter(function (v) { return v.id === base; })[0];
    return { id: base, quantity: packQ || 1, price: first ? first.p * (packQ || 1) : 0 };
  }
  function unitOf(el, packQ) {
    var u = variantsOf(el).filter(function (v) { return String(v.q) === '1'; })[0];
    if (u) return { id: u.id, quantity: packQ || 1, price: u.p * (packQ || 1) };
    return resolve(el, packQ);
  }
  function activePack(card) {
    if (!card) return 1;
    var b = card.querySelector('.bsa-pack.is-active');
    return b ? (parseInt((b.textContent || '').replace(/[^0-9]/g, ''), 10) || 1) : 1;
  }

  /* ---- product page: real pack prices + selected pack ---- */
  function packList() { return $('#packList'); }
  function fillPacks() {
    var list = packList(); if (!list) return;
    list.querySelectorAll('.packopt').forEach(function (o) {
      var p = o.getAttribute('data-vprice'), w = parseInt(o.getAttribute('data-vwas'), 10) || 0;
      if (!p) return;
      o.dataset.total = p;
      var n = o.querySelector('.packopt__price .now'), ws = o.querySelector('.packopt__price .was');
      if (n) n.textContent = '₹' + p;
      if (ws) ws.textContent = w > parseInt(p, 10) ? '₹' + w : '';
    });
    syncHeadline();
  }
  function syncHeadline() {
    var o = $('#packList .packopt.is-active'); if (!o) return;
    var p = parseInt(o.getAttribute('data-vprice'), 10), w = parseInt(o.getAttribute('data-vwas'), 10) || 0;
    if (!p) return;
    var pn = $('.pdp-price .now'), pw = $('.pdp-price .was'), ps = $('.pdp-price .save');
    if (pn) pn.textContent = '₹' + p;
    if (pw) pw.textContent = w > p ? '₹' + w : '';
    if (ps) ps.textContent = w > p ? 'Save ' + Math.round((w - p) / w * 100) + '%' : '';
    var btn = $('.pdp-cart [data-add]');
    if (btn && !btn.hasAttribute('data-nocart')) { btn.setAttribute('data-add', o.getAttribute('data-variant')); btn.setAttribute('data-price', p); }
  }
  document.addEventListener('click', function (e) { if (e.target.closest('#packList .packopt')) setTimeout(syncHeadline, 0); });
  window.addEventListener('load', function () { setTimeout(fillPacks, 250); setTimeout(fillPacks, 1200); });

  /* ---- mobile pack sheet with real variants ---- */
  function openSheet(cta) {
    var sheet = $('#psheet'), ov = $('#psheetOverlay'), grid = $('#psheetGrid'), title = $('#psheetTitle');
    if (!sheet || !grid) return false;
    var card = cta.closest('.bs-card');
    var name = cta.getAttribute('data-name') || cta.getAttribute('data-add');
    var imgEl = card ? card.querySelector('.bs-card__media img') : null; var img = imgEl ? imgEl.getAttribute('src') : '';
    var wtEl = card ? card.querySelector('.bs-card__meta-i') : null; var wt = wtEl ? wtEl.textContent.replace(/net\s*wt\.?\s*/i, '').trim() : '';
    var list = variantsOf(cta);
    if (list.length === 4 && list.every(function (v) { return ['2', '4', '6', '10'].indexOf(String(v.q)) > -1; })) list = list.map(function (v) { return Object.assign({}, v, { q: String(parseInt(v.q, 10) / 2) }); });
    list = list.sort(function (x, y) { return (parseInt(x.q, 10) || 0) - (parseInt(y.q, 10) || 0); });
    var unitV = list.filter(function (v) { return String(v.q) === '1'; })[0];
    var picked = list.filter(function (v) { return v.q === '1' || v.q === '3' || v.q === '5'; });
    list = picked.length ? picked : list.slice(0, 3);
    if (!list.length) return false;
    var base = list[0].p;
    if (title) title.textContent = name + ' — choose a pack';
    grid.innerHTML = list.map(function (v) {
      var q = parseInt(v.q, 10) || 1, now = v.p, was = v.w > v.p ? v.w : 0, per = Math.round(now / q);
      var off = was > now ? Math.round((was - now) / was * 100) : 0;
      return '<div class="popt">' +
        '<div class="popt__media">' +
          (off ? '<span class="popt__off">' + off + '% OFF</span>' : '') +
          (img ? '<img class="popt__img" src="' + img + '" alt="">' : '') +
          '<button class="popt__add" data-variant="' + v.id + '"' + (unitV ? ' data-unit="' + unitV.id + '" data-q="' + q + '"' : '') + ' data-pname="' + name + ' (Pack of ' + q + ')" data-pprice="' + now + '" data-pimg="' + img + '"' + (v.a === false ? ' disabled' : '') + '>' + (v.a === false ? 'SOLD OUT' : 'ADD') + '</button>' +
        '</div>' +
        '<div class="popt__name">Pack of ' + q + '</div>' +
        (wt ? '<div class="popt__wt">' + wt + (q > 1 ? ' × ' + q : '') + '</div>' : '') +
        '<div class="popt__price"><span class="n">₹' + now + '</span>' + (was > now ? '<span class="w">₹' + was + '</span>' : '') + '</div>' +
        '<div class="popt__per">₹' + per + '/pack</div>' +
      '</div>';
    }).join('');
    sheet.classList.add('open'); if (ov) ov.classList.add('open'); sheet.setAttribute('aria-hidden', 'false');
    return true;
  }
  function closeSheet() {
    var sheet = $('#psheet'), ov = $('#psheetOverlay');
    if (sheet) { sheet.classList.remove('open'); sheet.setAttribute('aria-hidden', 'true'); }
    if (ov) ov.classList.remove('open');
  }

  /* ---- intercept clicks before the demo handlers (window capture runs first) ---- */
  window.addEventListener('click', function (e) {
    var t = e.target;
    var stop = function () { e.preventDefault(); e.stopImmediatePropagation(); };

    /* Legacy demo links (product.html?id=…) would 404 on Shopify: use the card's real URL instead. */
    var med = t.closest('.bs-card__media');
    if (med && !t.closest('a') && !t.closest('.bs-card__add')) {
      var dh = med.getAttribute('data-href');
      if (dh && dh.charAt(0) !== '#') { stop(); window.location.href = dh; return; }
    }
    var leg = t.closest('a[href]');
    if (leg && /\.html([?#]|$)/.test(leg.getAttribute('href') || '')) {
      var rc = leg.closest('.bs-card'), ra = rc && rc.querySelector('a[href^="/products/"]');
      stop(); window.location.href = ra ? ra.getAttribute('href') : '/collections/all'; return;
    }

    var pk = t.closest('.bsa-pack[data-vid], .bsa-pack[data-vprice]');
    if (pk) {
      stop();
      var pcard = pk.closest('.bs-card');
      pk.parentElement.querySelectorAll('.bsa-pack').forEach(function (b) { b.classList.toggle('is-active', b === pk); });
      if (pcard) {
        var vp = parseInt(pk.getAttribute('data-vprice'), 10) || 0, vw = parseInt(pk.getAttribute('data-vwas'), 10) || 0;
        var pn = pcard.querySelector('.bsa-price .now'), pw = pcard.querySelector('.bsa-price .was');
        if (pn) pn.textContent = 'Rs. ' + vp;
        if (pw) { pw.textContent = vw > vp ? 'Rs. ' + vw : ''; pw.style.display = vw > vp ? '' : 'none'; }
        var padd = pcard.querySelector('.bs-card__add');
        if (padd) { if (pk.getAttribute('data-vid')) padd.setAttribute('data-add', pk.getAttribute('data-vid')); padd.setAttribute('data-price', vp); }
      }
      return;
    }

    var popt = t.closest('.popt__add[data-variant]');
    if (popt) {
      stop();
      var pu = parseInt(popt.getAttribute('data-unit'), 10), pq2 = parseInt(popt.getAttribute('data-q'), 10) || 1;
      var pimg = popt.getAttribute('data-pimg') || '', pprice = parseInt(popt.getAttribute('data-pprice'), 10) || 0;
      if (pu) addItems([{ id: pu, quantity: pq2 }], (popt.getAttribute('data-pname') || '').split(' (Pack of ')[0], { img: pimg, price: pprice }).catch(function () {});
      else addItems([{ id: parseInt(popt.getAttribute('data-variant'), 10), quantity: 1 }], popt.getAttribute('data-pname'), { img: pimg, price: pprice }).catch(function () {});
      closeSheet();
      return;
    }

    var fbt = t.closest('#fbtAdd');
    if (fbt) {
      stop();
      var items = [];
      document.querySelectorAll('.fbt-card').forEach(function (c) {
        var cb = c.querySelector('input'); if (!cb || !cb.checked) return;
        var sel = c.querySelector('.fbt-pack'); var q = sel ? (parseInt(sel.value, 10) || 1) : 1;
        var r = unitOf(c, q); items.push({ id: r.id, quantity: r.quantity });
      });
      addItems(items, items.length ? 'Bundle' : '').catch(function () {});
      return;
    }

    var pv = t.closest('[data-add="preview"]');
    if (pv) { stop(); toast((pv.getAttribute('data-name') || 'Combo') + ' — coming soon'); return; }

    /* FBT cards carry data-add only as data: a click inside must not trigger the demo add handler (keep default so the checkbox toggles). */
    if (t.closest('.fbt-card')) { e.stopImmediatePropagation(); return; }
    var a = t.closest('[data-add]:not(.fbt-card)');
    if (a && /^\d+$/.test(a.getAttribute('data-add') || '')) {
      var card = a.closest('.bs-card');
      if (window.innerWidth <= 600 && card && card.classList.contains('bs-card--alt') && variantsOf(a).length > 1 && !card.querySelector('.bsa-pack')) {
        stop(); openSheet(a); return;
      }
      stop();
      var qty = 1, id = parseInt(a.getAttribute('data-add'), 10), tot = 0;
      if (a.closest('.pdp-cart')) {
        var qv = $('#qVal'), nb = qv ? (parseInt(qv.textContent, 10) || 1) : 1;
        var po = $('#packList .packopt.is-active'), pq = po ? (parseInt(po.getAttribute('data-qty'), 10) || 1) : 1;
        var ru = unitOf(a, pq * nb); id = ru.id; qty = ru.quantity; tot = ru.price || (parseInt(a.getAttribute('data-price'), 10) || 0) * nb;
      } else if (card) {
        var rc = unitOf(a, activePack(card)); id = rc.id; qty = rc.quantity; tot = rc.price || 0;
      } else { tot = (parseInt(a.getAttribute('data-price'), 10) || 0) * qty; }
      var ucard = a.closest('.cd-uc'); var im = ucard ? ucard.querySelector('img') : (card ? card.querySelector('.bs-card__media img') : ($('#galMain') || document.querySelector('.gal__main img')));
      addItems([{ id: id, quantity: qty }], a.getAttribute('data-name') || '', { img: im ? (im.currentSrc || im.src) : '', price: tot }).catch(function () {});
      return;
    }

    var inc = t.closest('[data-inc]'), dec = t.closest('[data-dec]'), rm = t.closest('[data-rm]');
    var ctl = inc || dec || rm;
    if (ctl && ctl.closest('#drawer')) {
      stop();
      var line = parseInt(ctl.getAttribute('data-inc') || ctl.getAttribute('data-dec') || ctl.getAttribute('data-rm'), 10);
      var q = 0;
      if (!rm) { var span = ctl.parentElement.querySelector('span'); var cur = span ? parseInt(span.textContent, 10) || 0 : 0; q = inc ? cur + 1 : Math.max(0, cur - 1); }
      var rowEl = ctl.closest('.ci');
      if (rowEl) {
        var unit = parseInt(rowEl.getAttribute('data-unit'), 10) || 0;
        var qEl0 = rowEl.querySelector('.qty span'), q0 = qEl0 ? (parseInt(qEl0.textContent, 10) || 1) : 1;
        var tEl = $('#cartTotal'); if (tEl && unit) { var tv = parseInt((tEl.textContent || '').replace(/[^0-9]/g, ''), 10) || 0; tEl.textContent = '₹' + Math.max(0, tv + (q - q0) * unit); }
        if (q <= 0) { var list = rowEl.parentElement; rowEl.remove(); var k = 0; list.querySelectorAll('.ci:not(.ci--pending)').forEach(function (r2) { k++; r2.querySelectorAll('[data-inc],[data-dec],[data-rm]').forEach(function (b2) { if (b2.hasAttribute('data-inc')) b2.setAttribute('data-inc', k); if (b2.hasAttribute('data-dec')) b2.setAttribute('data-dec', k); if (b2.hasAttribute('data-rm')) b2.setAttribute('data-rm', k); }); }); if (!k) { var em = $('#drawerEmpty'); if (em) em.style.display = ''; var d0 = $('#drawer'); if (d0) d0.setAttribute('data-item-count', '0'); } rowEl = null; }
        else {
          var qs = rowEl.querySelector('.qty span'); if (qs) qs.textContent = q; setPk(rowEl, q);
          var bi = rowEl.querySelector('[data-inc]'), bd = rowEl.querySelector('[data-dec]');
          if (bi) bi.setAttribute('data-qty', q + 1); if (bd) bd.setAttribute('data-qty', q - 1);
        }
        var cc = $('#cartCount'), prev = rowEl ? rowEl.getAttribute('data-q') : null; var was = q0;
        if (cc) cc.textContent = Math.max(0, (parseInt(cc.textContent, 10) || 0) + (q - was));
        if (rowEl) rowEl.setAttribute('data-q', q);
      }
      var vidc = ctl.closest('.ci') && ctl.closest('.ci').getAttribute('data-vid');
      (vidc && !ctl.closest('.ci').classList.contains('ci--pending') ? post('cart/change.js', { id: String(vidc), quantity: q }) : changeLine(line, q)).catch(function () {});
      return;
    }

    if (t.closest('#cartClose') || (t.id === 'overlay')) { closeCart(); return; }
    if (t.closest('#psheetClose') || t.id === 'psheetOverlay') { closeSheet(); return; }
  }, true);

  /* ---- menu category filter: independent of the page script so it keeps working even if that script fails ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.mf-btn[data-filter]');
    var grid = document.getElementById('shopGrid');
    if (!b || !grid) return;
    e.stopImmediatePropagation();
    var f = b.getAttribute('data-filter');
    document.querySelectorAll('.mf-btn').forEach(function (x) { x.classList.toggle('is-active', x === b); });
    try { sessionStorage.setItem('surtiMenuFilter', f); } catch (err) {}
    var label = document.getElementById('filterLabel'); if (label) label.textContent = 'Filter: ' + b.textContent;
    var panel = document.getElementById('filterPanel'), toggle = document.getElementById('filterToggle');
    if (panel) panel.classList.remove('open'); if (toggle) toggle.classList.remove('open');
    var visible = 0;
    grid.querySelectorAll('.bs-card').forEach(function (c) {
      var hide = f !== 'all' && c.getAttribute('data-cat') !== f;
      c.classList.toggle('is-hidden', hide);
      if (!hide) visible++;
    });
    var es = document.getElementById('catEmpty');
    if (!es) { es = document.createElement('div'); es.id = 'catEmpty'; es.style.cssText = 'display:none;text-align:center;padding:52px 16px;color:#7a7a7a;font-weight:600;font-size:1rem;grid-column:1/-1'; grid.appendChild(es); }
    if (visible === 0) {
      var lb = b.querySelector('.cat-tile__label');
      es.textContent = 'More ' + (lb ? lb.textContent : b.textContent).replace(/\s+/g, ' ').trim() + ' coming soon.';
      es.style.display = '';
    } else { es.style.display = 'none'; }
  }, true);

  /* ---- menu sort: the original script reads price/rating from classes the cards do not have ---- */
  (function () {
    var grid = document.getElementById('shopGrid'), panel = document.getElementById('sortPanel');
    if (!grid || !panel) return;
    var order = null;
    function digits(el) { return el ? parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10) || 0 : 0; }
    function price(c) { return digits(c.querySelector('.bsa-price .now')); }
    function reviews(c) { return digits(c.querySelector('.rc-n')); }
    function title(c) { var n = c.querySelector('.bs-card__name'); return n ? n.textContent.trim().toLowerCase() : ''; }
    function created(c) { return parseInt(c.getAttribute('data-created'), 10) || 0; }
    function sortBy(v) {
      var cards = [].slice.call(grid.querySelectorAll('.bs-card'));
      if (!order) order = cards.slice();
      var arr = order.slice();
      if (v === 'price-asc') arr.sort(function (a, b) { return price(a) - price(b); });
      else if (v === 'price-desc') arr.sort(function (a, b) { return price(b) - price(a); });
      else if (v === 'az') arr.sort(function (a, b) { return title(a).localeCompare(title(b)); });
      else if (v === 'za') arr.sort(function (a, b) { return title(b).localeCompare(title(a)); });
      else if (v === 'bestselling') arr.sort(function (a, b) { return reviews(b) - reviews(a); });
      else if (v === 'date-old') arr.sort(function (a, b) { return created(a) - created(b); });
      else if (v === 'date-new') arr.sort(function (a, b) { return created(b) - created(a); });
      var frag = document.createDocumentFragment();
      arr.forEach(function (c) { frag.appendChild(c); });
      var empty = document.getElementById('catEmpty');
      grid.insertBefore(frag, empty && empty.parentNode === grid ? empty : null);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('#sortPanel .so-btn');
      if (!b) return;
      e.stopImmediatePropagation();
      panel.querySelectorAll('.so-btn').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      var lbl = document.getElementById('sortLabel'); if (lbl) lbl.textContent = b.textContent;
      panel.classList.remove('open');
      var tg = document.getElementById('sortToggle'); if (tg) { tg.classList.remove('open'); tg.setAttribute('aria-expanded', 'false'); }
      sortBy(b.getAttribute('data-sort'));
    }, true);
  })();

  /* ---- product cards: the biggest pack (5 / 10) is selected by default ---- */
  function selectBigPacks() {
    document.querySelectorAll('.bs-card .bsa-packs').forEach(function (box) {
      var best = null, bn = -1;
      box.querySelectorAll('.bsa-pack[data-vprice], .bsa-pack[data-vid]').forEach(function (b) { var n = parseInt(b.textContent, 10) || 0; if (n > bn) { bn = n; best = b; } });
      if (best && !best.classList.contains('is-active')) best.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectBigPacks); else selectBigPacks();
  window.addEventListener('load', function () { setTimeout(selectBigPacks, 150); });

  /* ---- initial state from the server ---- */
  if (document.readyState === 'complete') refresh(); else window.addEventListener('load', function () { setTimeout(refresh, 0); });
})();
